import { render, staticRenderFns } from "./secondAuth.vue?vue&type=template&id=679eb9c8&scoped=true"
import script from "./secondAuth.vue?vue&type=script&lang=js"
export * from "./secondAuth.vue?vue&type=script&lang=js"
import style0 from "./secondAuth.vue?vue&type=style&index=0&id=679eb9c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679eb9c8",
  null
  
)

export default component.exports